/**
 * @internal
 * CSS class names for image editing elements
 */
// eslint-disable-next-line etc/no-const-enum
export const enum ImageEditElementClass {
    /**
     * CSS class name for resize handle
     */
    ResizeHandle = 'r_resizeH',

    /**
     * CSS class name for rotate handle
     */
    RotateHandle = 'r_rotateH',

    /**
     * CSS class name for the container of rotate handle
     */
    RotateCenter = 'r_rotateC',

    /**
     * CSS class name for crop overlay
     */
    CropOverlay = 'r_cropO',

    /**
     * CSS class name for container of crop handle
     */
    CropContainer = 'r_cropC',

    /**
     * CSS class name for crop handle
     */
    CropHandle = 'r_cropH',
}
